<template>
  <div>
    <div class="sidebar-bg"/>
    <section class="section">
      <div class="container is-fullhd template-horizontal">
        <div class="is-hidden-mobile" style="background: rgb(249, 247, 247); padding: 10px; border: 1px solid rgb(228, 222, 222);">
          <TheSidebar :data="menu"/>
        </div>
        <router-view/>
      </div>
    </section>
  </div>
</template>

<script>
  import TheSidebar from '../pages/TheSidebar'
  import menu from '../menu'
  import highcharts from 'highcharts'
  import Export from 'highcharts/modules/exporting'
  import Drilldown from 'highcharts/modules/drilldown'
  Drilldown(highcharts)
  Export(highcharts)
    export default {
        components:{TheSidebar},
        data() {
            return {

            }
        },
        methods:{
          
        },
      computed: {        
        menu() {
          return menu
        }
      }
    }
</script>
<style scoped>
.section {
  padding: 0px !important;
}
</style>


// WEBPACK FOOTER //
// Admin.vue?89dc81ae